import React from 'react';

type Props = {
  width: string
}

export const SteeringWheelSvg = (props: Props): React.ReactElement => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={props.width} viewBox="0 0 83 83">
    <g id="Ikona_-_volant" data-name="Ikona - volant" transform="translate(-251 -141)">
      <path id="Union_3" data-name="Union 3" d="M29.273,48V29.622A21.479,21.479,0,0,1,14.992,17.739H0V7.3H13.125a21.25,21.25,0,0,1,1.043-5.217h.007A3.347,3.347,0,0,1,17.25.008V0H52.273c1.557,0,2.3.987,2.681,2.464A21.236,21.236,0,0,1,55.876,7.3H69V17.739H54.009A21.448,21.448,0,0,1,39.727,29.622V48Z"
        transform="translate(258 172)" fill="#ef7f1a"/>
      <path id="Subtraction_2" data-name="Subtraction 2"
        d="M41.5,83a41.307,41.307,0,0,1-23.2-7.088A41.622,41.622,0,0,1,3.261,57.653,41.445,41.445,0,0,1,7.088,18.3,41.62,41.62,0,0,1,25.346,3.261,41.445,41.445,0,0,1,64.7,7.088,41.624,41.624,0,0,1,79.739,25.346,41.444,41.444,0,0,1,75.912,64.7,41.621,41.621,0,0,1,57.654,79.739,41.24,41.24,0,0,1,41.5,83Zm0-72.56A31.06,31.06,0,1,0,72.56,41.5,31.095,31.095,0,0,0,41.5,10.44Z"
        transform="translate(251 141)" fill="#1e3050"/>
    </g>
  </svg>

}
